import { format, isValid, parseISO, startOfMonth } from 'date-fns';

import {
  IMedicaidPlan,
  IMedicaidPlanCreateRequest,
  IMedicaidPlanUpdateRequest,
} from '~/services/api/medicaidPlan/types';

export interface IMedicaidPlanFormValues {
  medicaidTypeId: number | '';
  medicaidId: string;
  effectiveDate: string;
  recertificationDate: string;
  isRecertificationRequired: boolean;
}

const parseMonth = (value?: string | null): Date | null => {
  const date = value ? parseISO(value) : null;
  return date && isValid(date) ? startOfMonth(date) : null;
};

export const toMonthStart = (value?: string | null): string | null => {
  const month = parseMonth(value);
  return month ? format(month, 'yyyy-MM-dd') : null;
};

export const getDefaultValues = (
  plan: IMedicaidPlan | null,
  isRecertificationRequired: boolean,
): IMedicaidPlanFormValues => ({
  medicaidTypeId: plan?.medicaidType?.id ?? '',
  medicaidId: plan?.medicaidId ?? '',
  effectiveDate: plan?.effectiveDate ?? '',
  recertificationDate: plan?.recertificationDate ?? '',
  isRecertificationRequired,
});

const getTypeId = (
  values: IMedicaidPlanFormValues,
  isExpansion: boolean,
  plan: IMedicaidPlan | null,
): number | null => {
  if (!isExpansion) return plan?.medicaidType?.id ?? null;
  return values.medicaidTypeId === '' ? null : values.medicaidTypeId;
};

export const toUpdateRequest = (
  values: IMedicaidPlanFormValues,
  isExpansion: boolean,
  plan: IMedicaidPlan | null,
): IMedicaidPlanUpdateRequest => ({
  medicaidTypeId: getTypeId(values, isExpansion, plan),
  medicaidId: values.medicaidId.trim() || null,
  effectiveDate: isExpansion ? toMonthStart(values.effectiveDate) : plan?.effectiveDate ?? null,
  recertificationDate:
    isExpansion || values.isRecertificationRequired
      ? toMonthStart(values.recertificationDate)
      : null,
});

export const toCreateRequest = (
  values: IMedicaidPlanFormValues,
  isExpansion: boolean,
): IMedicaidPlanCreateRequest => toUpdateRequest(values, isExpansion, null);
